/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs */

const es_components_upgrade_plan_modal_downgrade_button = /** @type {(inputs: Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degradar Plan`)
};

const en_components_upgrade_plan_modal_downgrade_button = /** @type {(inputs: Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downgrade Plan`)
};

/**
* | output |
* | --- |
* | "Downgrade Plan" |
*
* @param {Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_downgrade_button = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Downgrade_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_downgrade_button(inputs)
	return en_components_upgrade_plan_modal_downgrade_button(inputs)
});
export { components_upgrade_plan_modal_downgrade_button as "components.upgrade_plan_modal.downgrade_button" }